import { handleActions, combineActions } from 'redux-actions';
import { mkQcsSyncResourceStore } from 'data/qcsSyncResourceTypes';
import { upsertResources, completeWithError } from 'data/qcsSyncResourceReducerHelpers';

import * as actions from './actions';
import { makeProfileFull } from './types';

export const reducer = handleActions({
  [combineActions(
    actions.getProfileSuccess,
    actions.updateProfileSuccess,
  )]: (state, { payload: data }) => upsertResources(state, data),

  [actions.updateProfile]: (state, { payload: data }) => upsertResources(state, {resources: [makeProfileFull(data)]}),

  [actions.getProfile]: (state) => state.merge({ isLoading: true }),

  [combineActions(
    actions.updateProfileFailure,
    actions.getProfileFailure,
  )]: (state, { payload: error }) => completeWithError(state, error),

}, mkQcsSyncResourceStore());

export const REDUCER_KEY = 'profileStore';
export default reducer;
